import MedicalReimbursementService from '../../../../../services/medical-reimbursement'
import adminMedicalReimbursementApprovalPopupStore from '../../../../../store/adminMedicalReimbursementApprovalPopupStore'
import authStore from '../../../../../store/authStore'
import { ApprovalPopupProps } from './props'

export default function useApprovalPopupViewModel(props: ApprovalPopupProps) {
  const user = authStore(state => state.user)
  const open = adminMedicalReimbursementApprovalPopupStore(state => state.open)
  const approvalStatus = adminMedicalReimbursementApprovalPopupStore(state => state.approvalStatus)
  const data = adminMedicalReimbursementApprovalPopupStore(state => state.data)
  const isLoading = adminMedicalReimbursementApprovalPopupStore(state => state.isLoading)

  function onClose() {
    if (!!props.onClose) props.onClose()
    adminMedicalReimbursementApprovalPopupStore.setState({
      approvalStatus: null,
      data: null,
      open: false,
      isLoading: false,
      isError: false,
      isSuccess: false,
    })
  }

  async function onConfirm() {
    if (!!data && !!approvalStatus) {
      adminMedicalReimbursementApprovalPopupStore.setState({ isLoading: false, isError: false, isSuccess: false })
      await MedicalReimbursementService.setApprovalById({
        id: data.id,
        approvalBy: user?.displayName ?? user?.email ?? user?.uid ?? null,
        approvalStatus: approvalStatus,
      })
        .then(() => {
          adminMedicalReimbursementApprovalPopupStore.setState({ isLoading: false, isSuccess: true })
        })
        .catch(error => {
          console.log(error)
          adminMedicalReimbursementApprovalPopupStore.setState({ isLoading: false, isError: true })
        })
        .finally(() => {
          if (!!props.onConfirm) props.onConfirm()
          onClose()
        })
    }
  }

  return {
    open,
    approvalStatus,
    data,
    onClose,
    onConfirm,
    isLoading,
  }
}
